var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../api/axios";
import { useEffect, useState } from "react";
export var CartSelectionModeType;
(function (CartSelectionModeType) {
    CartSelectionModeType[CartSelectionModeType["NONE"] = 0] = "NONE";
    CartSelectionModeType[CartSelectionModeType["CAN_ADD_REMOVE_MEALS"] = 10] = "CAN_ADD_REMOVE_MEALS";
    CartSelectionModeType[CartSelectionModeType["CAN_ADD_REMOVE_RECIPES"] = 20] = "CAN_ADD_REMOVE_RECIPES";
})(CartSelectionModeType || (CartSelectionModeType = {}));
export var RecipeDisplayNameType;
(function (RecipeDisplayNameType) {
    RecipeDisplayNameType[RecipeDisplayNameType["SHORT_NAME"] = 0] = "SHORT_NAME";
    RecipeDisplayNameType[RecipeDisplayNameType["LONG_NAME"] = 10] = "LONG_NAME";
})(RecipeDisplayNameType || (RecipeDisplayNameType = {}));
export var DefaultDaySectionExpansionType;
(function (DefaultDaySectionExpansionType) {
    DefaultDaySectionExpansionType[DefaultDaySectionExpansionType["EXPANDED"] = 0] = "EXPANDED";
    DefaultDaySectionExpansionType[DefaultDaySectionExpansionType["COLLAPSED"] = 10] = "COLLAPSED";
})(DefaultDaySectionExpansionType || (DefaultDaySectionExpansionType = {}));
export var DefaultCartText;
(function (DefaultCartText) {
    DefaultCartText["PLAN_NAME"] = "Plan name";
    DefaultCartText["START_DATE"] = "START_DATE";
    DefaultCartText["SUBSCRIPTION_PERIOD"] = "Subscription Period";
    DefaultCartText["OMISSIONS"] = "Omissions";
    DefaultCartText["DELIVERY_METHOD"] = "Delivery Method";
    DefaultCartText["RECIPE_TYPE"] = "Recipe Type";
    DefaultCartText["MEAL_SIZE"] = "Meal size";
    DefaultCartText["SUBSCRIPTION_DISCOUNT"] = "Subscription Discount";
    DefaultCartText["PICKUP_LOCATION"] = "Pickup location";
    DefaultCartText["POSTAL_CODE"] = "Postal code";
    DefaultCartText["PRODUCT_LABEL"] = "Addons";
    DefaultCartText["SUBSCRIPTION_SECTION_LABEL"] = "Subscriptions";
    DefaultCartText["PRICING"] = "Pricing";
    DefaultCartText["SUBTOTAL"] = "Subtotal";
    DefaultCartText["TAX"] = "Tax";
    DefaultCartText["TOTAL"] = "Total";
    DefaultCartText["DELIVERY"] = "Delivery";
    DefaultCartText["DISCOUNT"] = "Discount";
    DefaultCartText["COUPON"] = "Coupon";
    DefaultCartText["SUB_DISCOUNT"] = "Sub. Discount";
    DefaultCartText["SHORT_WEEK_INDICATOR_MEALS"] = "Your first order is a short week due to your start date.";
    DefaultCartText["SHORT_WEEK_INDICATOR_PRODUCTS"] = "The following products are not available due to your start date.";
    DefaultCartText["SURCHARGE"] = "Surcharge";
    DefaultCartText["NEXT_ORDER_SUBTOTAL"] = "Next Order's Subtotal";
    DefaultCartText["BALANCE_DUE"] = "Balance Due";
    DefaultCartText["AMOUNT_PAID"] = "Amount Paid";
    DefaultCartText["ACCOUNT_CREDIT"] = "Account Credit";
    DefaultCartText["GIFT_CARD"] = "GiftCard";
})(DefaultCartText || (DefaultCartText = {}));
const getSettingsHelper = (sku, settingsCallback, errorCallback, loadingCallback) => __awaiter(void 0, void 0, void 0, function* () {
    yield axiosPrivate
        .get(`/Account/CartSettings?sku=${sku}`)
        .then(({ data }) => {
        // Check for failed state
        if (data.success === false)
            errorCallback("Failed to load the SKU for your order.");
        // Assert to the compiler the type of the response.
        const { CartSettings } = data;
        CartSettings.HidePrices = data.HidePrices;
        // Transform the data model to something clientside friendly.
        settingsCallback(convertToCartVisibilitySettings(CartSettings, CartSettings.HidePrices));
    })
        .catch((err) => {
        console.log(err);
        errorCallback("Failed to load the SKU for your order.");
    });
    if (loadingCallback) {
        loadingCallback(false);
    }
});
/**
 * useCartSettings(sku, cartSettings) - get the cart settings configured for a
 * given sku if they're not already loaded.
 *
 * @param {string} sku
 * @param {CartVisibilitySettings | undefined} cartSettings
 * @return {*}
 */
export const useCartSettings = (sku, cartSettings = undefined) => {
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState(cartSettings);
    const [error, setError] = useState(undefined);
    useEffect(() => {
        if (!settings) {
            setLoading(true);
            getSettingsHelper(sku, setSettings, setError, setLoading);
        }
    }, []);
    return { settings, loading, error };
};
/**
 * Convert the JSON object to CartVisibilitySettings for use in Order Summary.
 *
 * @param cartSettings - Cart Settings Configuration Model
 * @param hidePrices - SkipPayment Resource Lookup
 * @returns
 */
export const convertToCartVisibilitySettings = (cartSettings, hidePrices, showNoBalanceDueMessage = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    return {
        planName: {
            display: cartSettings.DisplayPlanName,
            label: (_a = cartSettings.PlanNameDisplayText) !== null && _a !== void 0 ? _a : DefaultCartText.PLAN_NAME,
        },
        startDate: {
            display: cartSettings.DisplayStartDate,
            label: (_b = cartSettings.StartDateDisplayText) !== null && _b !== void 0 ? _b : DefaultCartText.START_DATE,
        },
        renewalPeriod: {
            display: cartSettings.DisplayRenewalPeriod,
            label: DefaultCartText.SUBSCRIPTION_PERIOD,
        },
        omissions: {
            display: cartSettings.DisplayOmissions,
            label: (_c = cartSettings.OmissionsDisplayText) !== null && _c !== void 0 ? _c : DefaultCartText.OMISSIONS,
        },
        deliveryMethod: {
            display: cartSettings.DisplayDeliveryMethod,
            label: (_d = cartSettings.DeliveryMethodDisplayText) !== null && _d !== void 0 ? _d : DefaultCartText.DELIVERY_METHOD,
        },
        recipeType: {
            display: cartSettings.DisplayRecipeType,
            label: (_e = cartSettings.RecipeTypeDisplayText) !== null && _e !== void 0 ? _e : DefaultCartText.RECIPE_TYPE,
        },
        mealSize: {
            display: cartSettings.DisplayMealSize,
            label: (_f = cartSettings.MealSizeDisplayText) !== null && _f !== void 0 ? _f : DefaultCartText.MEAL_SIZE,
        },
        subscriptionDiscount: {
            display: cartSettings.DisplaySubscriptionDiscount,
            label: (_g = cartSettings.SubscriptionDiscountTextDisplay) !== null && _g !== void 0 ? _g : DefaultCartText.SUBSCRIPTION_DISCOUNT,
        },
        location: {
            display: cartSettings.DisplayLocation,
            label: (_h = cartSettings.PickupLocationDisplayText) !== null && _h !== void 0 ? _h : DefaultCartText.PICKUP_LOCATION,
        },
        postalCode: {
            display: cartSettings.DisplayLocation,
            label: (_j = cartSettings.PostalCodeDisplayText) !== null && _j !== void 0 ? _j : DefaultCartText.POSTAL_CODE,
        },
        dayPrices: {
            display: cartSettings.DisplayDayPrices,
        },
        mealPrices: {
            display: cartSettings.DisplayMealPrices,
        },
        discountPerMeal: {
            display: cartSettings.DisplayDiscountedPricePerMeal,
        },
        products: {
            label: DefaultCartText.PRODUCT_LABEL,
        },
        recipe: {
            display: cartSettings.DisplayRecipes,
            unselectedText: cartSettings.UnselectedRecipeText,
        },
        subscriptionSection: {
            display: cartSettings.DisplaySubscriptionSection,
            label: (_k = cartSettings.SubscriptionSectionDisplayText) !== null && _k !== void 0 ? _k : DefaultCartText.SUBSCRIPTION_SECTION_LABEL,
        },
        pricing: {
            label: (_l = cartSettings.PricingTextDisplay) !== null && _l !== void 0 ? _l : DefaultCartText.PRICING,
        },
        subtotal: {
            label: (_m = cartSettings.SubtotalTextDisplay) !== null && _m !== void 0 ? _m : DefaultCartText.SUBTOTAL,
        },
        coupon: {
            label: (_o = cartSettings.CouponTextDisplay) !== null && _o !== void 0 ? _o : DefaultCartText.COUPON,
        },
        mealDiscount: {
            label: (_p = cartSettings.MealDiscountTextDisplay) !== null && _p !== void 0 ? _p : DefaultCartText.DISCOUNT,
        },
        delivery: {
            label: (_q = cartSettings.DeliveryTextDisplay) !== null && _q !== void 0 ? _q : DefaultCartText.DELIVERY,
        },
        tax: {
            label: (_r = cartSettings.TaxTextDisplay) !== null && _r !== void 0 ? _r : DefaultCartText.TAX,
        },
        total: {
            label: (_s = cartSettings.TotalTextDisplay) !== null && _s !== void 0 ? _s : DefaultCartText.TOTAL,
        },
        surcharge: {
            label: (_t = cartSettings.SurchargeTextDisplay) !== null && _t !== void 0 ? _t : DefaultCartText.SURCHARGE,
        },
        displayOfQuantitySelectedText: {
            display: (_u = cartSettings.EnableDisplayOfQuantitySelectedText) !== null && _u !== void 0 ? _u : true,
        },
        shortWeekIndicatorForMeals: {
            display: cartSettings.DisplayShortWeekIndicatorForMeals,
            label: (_v = cartSettings.ShortWeekIndicatorForMealsText) !== null && _v !== void 0 ? _v : DefaultCartText.SHORT_WEEK_INDICATOR_MEALS,
        },
        shortWeekIndicatorForProducts: {
            display: cartSettings.DisplayShortWeekIndicatorForProducts,
            label: (_w = cartSettings.ShortWeekIndicatorForProductsText) !== null && _w !== void 0 ? _w : DefaultCartText.SHORT_WEEK_INDICATOR_PRODUCTS,
        },
        nextOrderSubtotal: {
            label: (_x = cartSettings.NextOrderSubtotalDisplayText) !== null && _x !== void 0 ? _x : DefaultCartText.NEXT_ORDER_SUBTOTAL,
        },
        balanceDue: {
            label: DefaultCartText.BALANCE_DUE,
        },
        amountPaid: {
            label: DefaultCartText.AMOUNT_PAID,
        },
        accountCredit: {
            label: DefaultCartText.ACCOUNT_CREDIT,
        },
        giftCard: {
            label: DefaultCartText.GIFT_CARD,
        },
        noBalanceDueMessage: {
            display: showNoBalanceDueMessage,
            label: cartSettings.NoBalanceDueMessage,
        },
        hidePrices,
        cartSelectionMode: cartSettings.CartSelectionMode,
        recipeDisplayNameType: cartSettings.RecipeDisplayNameType,
        detailSectionHeading: cartSettings.CartDetailSectionHeading,
        productSectionHeading: cartSettings.ProductSectionHeading,
        isDayDefaultExpanded: cartSettings.DefaultDaySectionExpansion === DefaultDaySectionExpansionType.EXPANDED,
        emptyCartDisplayMessage: cartSettings.EmptyCartDisplayMessage,
        displayContinueButton: cartSettings.DisplayContinueButton
    };
};
